// ABOUTME: Horizontal ellipsis (three dots) menu icon
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const EllipsisIcon = ({ className = "", size = 18, color = "#6B7280" }: IconProps) => (
  <svg
    width={size}
    height={size * 0.222}
    viewBox="0 0 18 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.6665 3.66732C16.587 3.66732 17.3332 2.92113 17.3332 2.00065C17.3332 1.08018 16.587 0.333984 15.6665 0.333984C14.746 0.333984 13.9998 1.08018 13.9998 2.00065C13.9998 2.92113 14.746 3.66732 15.6665 3.66732Z"
      fill={color}
    />
    <path
      d="M8.99984 3.66732C9.92031 3.66732 10.6665 2.92113 10.6665 2.00065C10.6665 1.08018 9.92031 0.333984 8.99984 0.333984C8.07936 0.333984 7.33317 1.08018 7.33317 2.00065C7.33317 2.92113 8.07936 3.66732 8.99984 3.66732Z"
      fill={color}
    />
    <path
      d="M2.33317 3.66732C3.25365 3.66732 3.99984 2.92113 3.99984 2.00065C3.99984 1.08018 3.25365 0.333984 2.33317 0.333984C1.4127 0.333984 0.666504 1.08018 0.666504 2.00065C0.666504 2.92113 1.4127 3.66732 2.33317 3.66732Z"
      fill={color}
    />
  </svg>
)
